import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaUser, FaEnvelope, FaPhone, FaLock, FaStar } from "react-icons/fa";
import "./astrology.css";
import { useContext } from "react";
import AlertContext from "../../contexts/AlertContext";

const AstrologerRegister = () => {
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    expertise: "",
    password: "",
    experience: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://back.varankal.com/api/astrologers/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // add this if using cookies/sessions
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || `HTTP error! Status: ${response.status}`);
      }

      showAlert("Registration successful! Redirecting to login...");
      setFormData({
        name: "",
        email: "",
        phone: "",
        expertise: "",
        password: "",
        experience: "",
      });

      navigate("/astrologylogin");
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert(error.message || "Failed to register. Please check the console.", "error");
    }
  };

  return (
    <div className="register-containerT33">
      <div className="register-cardT33">
        <h2 className="register-titleT33">🔮 Astrologer Registration</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-groupT33">
            <FaUser className="input-iconT33" />
            <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
          </div>
          <div className="input-groupT33">
            <FaEnvelope className="input-iconT33" />
            <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="input-groupT33">
            <FaPhone className="input-iconT33" />
            <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
          </div>
          <div className="input-groupT33">
            <FaStar className="input-iconT33" />
            <select name="expertise" value={formData.expertise} onChange={handleChange} required>
              <option value="">Select Expertise</option>
              <option value="Vedic Astrology">Vedic Astrology</option>
              <option value="Marriage Compatibility">Marriage Compatibility</option>
              <option value="Palm Reading & Tarot">Palm Reading & Tarot</option>
            </select>
          </div>
          <div className="input-groupT33">
            <FaStar className="input-iconT33" />
            <input type="number" name="experience" placeholder="Experience (Years)" value={formData.experience} onChange={handleChange} required />
          </div>
          <div className="input-groupT33">
            <FaLock className="input-iconT33" />
            <input type="password" name="password" placeholder="Create Password" value={formData.password} onChange={handleChange} required />
          </div>
          <button type="submit" className="register-btnT33">✨ Register Now</button>
        </form>

        <p className="login-linkT33">
          Already have an account? <Link to="/astrologylogin">Login Here</Link>
        </p>
      </div>
    </div>
  );
};

export default AstrologerRegister;
